export default __webpack_public_path__ + "809b2ace50db54e6eb4664b5fa0ce7ec.png";